import React from 'react';
import { contact } from '../data/site';
const cells = [{
  title: 'Commercial vehicles, our focus',
  detail: 'Semis, box trucks, fleets and trailers'
}, {
  title: 'Brighton, Southeast Michigan',
  detail: `${contact.street} ${contact.cityLine}`
}, {
  title: 'Part of the Garrett family',
  detail: 'Garrett Auto & Truck Service · Garrett established 1958'
}];
export function TrustStrip() {
  return <section aria-label="About Motor City at a glance" className="border-b border-line bg-paper" data-id="element-230" data-mp="2aco32mtfwvtd">
      <ul className="mx-auto grid max-w-[1320px] divide-y divide-line px-5 sm:px-8 md:grid-cols-3 md:divide-x md:divide-y-0 lg:px-12" data-id="element-231" data-mp="25d1p2b5sfbji">
        {cells.map(cell => <li key={cell.title} className="py-7 md:px-8 md:py-9 md:first:pl-0 md:last:pr-0" data-id="element-232" data-mp="1wcmt8hv76e1r">
            <span aria-hidden="true" className="block h-[2px] w-6 bg-brand" data-id="element-233" data-mp="1wezfh77znakm" />
            <p className="mt-4 font-display text-[24px] font-semibold uppercase leading-tight tracking-[0.02em] text-ink lg:text-[26px]" data-id="element-234" data-mp="3urg8cfy1e67m">
              {cell.title}
            </p>
            <p className="mt-1.5 text-[15px] text-steel" data-id="element-235" data-mp="3mr01cv9lolq8">{cell.detail}</p>
          </li>)}
      </ul>
    </section>;
}